import { render, staticRenderFns } from "./EditableBarcode.vue?vue&type=template&id=2cfceb21&scoped=true&"
import script from "./EditableBarcode.vue?vue&type=script&lang=js&"
export * from "./EditableBarcode.vue?vue&type=script&lang=js&"
import style0 from "./EditableBarcode.vue?vue&type=style&index=0&id=2cfceb21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfceb21",
  null
  
)

export default component.exports